import React, { useState } from "react";
import styles from "../../../../styles/modal/User/copywriterDashboardFeedbackModal.module.scss";
import { Box } from "@mui/system";
import { Button } from "@imarabinda/antd";
import UserAttachFileIcon from "../../../../ui/Icons/UserAttachFileIcon";
import { Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "react-query";
import { FeedbackMutationF } from "../../../../api/functions/copywritersDashboard.api";

// schema

const schema = yup.object().shape({
  dashboard: yup.string().max(320).required("This filed is required"),
  improved: yup.string().max(320).required("This filed is required"),

  experience: yup.string().max(320).required("This filed is required"),
});

const CopywriterDashboardFeedbackModal = (setOpen) => {
  console.warn(
    "🚀 ~ file: CopywriterDashboardFeedbackModal.jsx:23 ~ CopywriterDashboardFeedbackModal ~ setOpen:",
    setOpen
  );
  /*****************backdrop*****************/
  const { mutateAsync: FeedbackMutation } = useMutation({
    mutationFn: FeedbackMutationF,
  });
  const {
    handleSubmit,
    control,
    register,

    reset,
    formState: { errors },
    formState,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [snackOpen, setSnackOpen] = React.useState(false);

  const handleClick = () => {
    setSnackOpen(true);
  };
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };

  /*****************backdrop*****************/
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);

  const TotalArray = [selectedFile, selectedFile1, selectedFile2];

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    setSelectedFile1(file);
  };

  const handleFileChange2 = (event) => {
    const file = event.target.files[0];
    setSelectedFile2(file);
  };

  const onSubmit = (data) => {
    const formData = new FormData();
    {
      TotalArray === null ? "" : formData.append("attachments[]", TotalArray);
    }

    formData.append("what_you_like", data?.dashboard);
    formData.append("what_improve", data?.improved);
    formData.append("suggestions", data?.experience);

    FeedbackMutation(formData).then((response) => {
      if (response.id) {
        setSnackOpen(true);

        // setOpen.setOpen();
      }
    });
  };

  return (
    <Box className={styles.feedbackModalWrapper}>
      <Box className={styles.feedbackModalHeader}>
        <h4>Help Us Improve Your Experience!</h4>
      </Box>

      <Box className={styles.feedbackModalBody}>
        <Box className={styles.feedbackItem}>
          <label>What do you like most about our dashboard?</label>
          <textarea
            placeholder="Your favorite features, things you find helpful, etc."
            {...register("dashboard")}
          ></textarea>
          {errors.dashboard && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.dashboard.message}
            </p>
          )}

          <Box className={styles.attachFile}>
            <input type="file" onChange={handleFileChange} />
            <Button>
              <UserAttachFileIcon /> Attach a file
            </Button>
          </Box>
          {selectedFile && <p> {selectedFile.name}</p>}
        </Box>

        <Box className={styles.feedbackItem}>
          <label>What do you think could be improved?</label>
          <textarea
            placeholder="Any features that are difficult to use, things you feel are missing, etc."
            {...register("improved")}
          ></textarea>
          {errors.improved && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.improved.message}
            </p>
          )}
          <Box className={styles.attachFile}>
            <input type="file" onChange={handleFileChange1} />
            <Button>
              <UserAttachFileIcon /> Attach a file
            </Button>
          </Box>
          {selectedFile1 && <p> {selectedFile1.name}</p>}
        </Box>

        <Box className={styles.feedbackItem}>
          <label>
            Do you have any other suggestions or comments to enhance your
            experience?
          </label>
          <textarea
            placeholder="Any other thoughts or ideas you might have."
            {...register("experience")}
          ></textarea>
          {errors.experience && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.experience.message}
            </p>
          )}
          <Box className={styles.attachFile}>
            <input type="file" onChange={handleFileChange2} />
            <Button>
              <UserAttachFileIcon /> Attach a file
            </Button>
          </Box>
          {selectedFile2 && <p> {selectedFile2.name}</p>}
        </Box>
      </Box>

      <Box className={styles.feedbackModalFooter}>
        <h4>
          By sharing your feedback, you're helping us make your experience even
          better.
        </h4>
        <Button type="button" onClick={handleSubmit(onSubmit)}>
          Share your Feedback
        </Button>
      </Box>

      <Backdrop
        open={snackOpen}
        onClick={handleCloseSnack}
        sx={{ zIndex: "11" }}
        className={styles.snackBackDrop}
      >
        <Snackbar
          open={snackOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          message={
            <>
              {/* <Box className='textBeforeSave'>
                <CircularProgress size={20} thickness={7} color="inherit" />
                <span className='textSave'>Sending</span>
              </Box> */}

              <Box className="textAfterSave">
                <span className="textSave">
                  Thank you! We trully appreciate your valuable feedback.
                </span>
              </Box>
            </>
          }
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          ContentProps={{
            sx: {
              justifyContent: "center",
              minWidth: "auto !important",
              background: "#000",
              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
              height: "45px",
              padding: "0",
              "& .textBeforeSave": {
                minWidth: "219px !important",
                display: "flex",
                justifyContent: "center",
              },
              "& .textAfterSave": {
                minWidth: "425px !important",
                display: "flex",
                justifyContent: "center",
              },
              "& .MuiSnackbarContent-message": {
                fontWeight: "500",
                fontSize: "13px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                "& .MuiCircularProgress-root": {
                  marginRight: "13px",
                },
                "& .textSave": {
                  display: "inline-block",
                  fontSize: "13px",
                  fontWeight: "600",
                },
              },
            },
          }}
        />
      </Backdrop>
    </Box>
  );
};

export default CopywriterDashboardFeedbackModal;
